import MyProfile from './myProfile'
import UserProfile from './userProfile'
import productComments from './productComments'

export default [
    MyProfile,
    UserProfile,
    productComments
]